import api from './api';

export const getUser = () =>
  api.get('/api/v1/user')

export const putUser = info =>
  api.put('/api/v1/user', info)

export const putUserPassword = passwordInfo =>
  api.put('/api/v1/user/password', passwordInfo)